import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import {
  DashboardExportButton,
  DashboardSectionHeader,
} from "src/components/common";
import MonthRangePicker from "src/components/reusable/MonthRangePicker/MonthRangePicker";
import "../Styles/CltvDashboardHeader.scss";

type CltvDashboardHeaderProps = {
  rangeSummary: string;
  startDate: string;
  endDate: string;
  onRangeChange: (_range: { start: string; end: string }) => void;
  pdfContainerRef: RefObject<HTMLElement>;
  exportDisabled: boolean;
  onBeforeCapture: () => Promise<void>;
  onAfterCapture: () => void;
};

const CltvDashboardHeader: FC<CltvDashboardHeaderProps> = ({
  rangeSummary,
  startDate,
  endDate,
  onRangeChange,
  pdfContainerRef,
  exportDisabled,
  onBeforeCapture,
  onAfterCapture,
}) => {
  const { t } = useTranslation();

  return (
    <DashboardSectionHeader
      className="cltv-dashboard__top"
      title={t("cltv.title")}
      subtitle={`${t("cltv.subtitle")} • ${rangeSummary}`}
      actionsClassName="dashboard-section-header__actions--filters"
      actions={
        <div className="dashboard-section-header__control-row">
          <div className="dashboard-section-header__control dashboard-section-header__control--wide">
            <MonthRangePicker
              startDate={startDate}
              endDate={endDate}
              onRangeChange={onRangeChange}
              allowUnlimitedHistory
              startPlaceholder={t("monthRangePicker.secondaryMonth")}
              endPlaceholder={t("monthRangePicker.primaryMonth")}
            />
          </div>
          <DashboardExportButton
            dashboardName="CLTV"
            dateRange={{ startDate, endDate }}
            containerRef={pdfContainerRef}
            disabled={exportDisabled}
            onBeforeCapture={onBeforeCapture}
            onAfterCapture={onAfterCapture}
          />
        </div>
      }
    />
  );
};

export default CltvDashboardHeader;
